import React, { useContext, useEffect, useState } from 'react';
import { Form, Field, ErrorMessage, Formik } from 'formik';
import { CreateLoginValidationSchema } from '../ValidationSchema/CreateLoginValidationSchema';
import { Link, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { ConfigContext } from '../Context/ConfigContext';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const CreateAccount = () => {
    const { apiURL } = useContext(ConfigContext)
    const navigate = useNavigate()

    const initialValues = {
        username: '',
        email: '',
        password: '',
        confirmPassword: '',
        terms: false,
    }

    const onSubmit = async (values, { setSubmitting, setErrors, event }) => {
        event?.preventDefault();

        try {
            let body = {
                customer_name: values.username,
                customer_email: values.email,
                customer_password: values.password,
                terms: values.terms,
            };

            const apiEndpoint = `${apiURL}Users/UserSignUp`;
            const response = await axios.post(apiEndpoint, body);

            if (response.data.success === true) {
                toast.success("Account created successfully!");
                navigate("/Login");
            }

        } catch (error) {
            if (error.response && error.response.data) {
                setErrors({ username: error.response.data.message || 'Account not created' });
                toast.error(error.response.data.message || "Account not created");
            } else {
                setErrors({ username: 'An error occurred. Please try again.' });
                toast.error("An error occurred. Please try again.");
            }
        } finally {
            setSubmitting(false);
        }
    };


    useEffect(() => {
        document.title = 'StoneSkill | CreateAccount'
    })

    return (
        <>
            <div className="main pages">
                <div className="page-header breadcrumb-wrap">
                    <div className="container">
                        <div className="breadcrumb">
                            <Link to="/" rel="nofollow"><i className="fi-rs-home mr-5" />Home</Link>
                            <span /> Pages <span /> My Account
                        </div>
                    </div>
                </div>
                <div className="page-content pt-150 pb-150">
                    <div className="container">
                        <div className="row">
                            <div className="col-xl-8 col-lg-10 col-md-12 m-auto">
                                <div className="row">
                                    <h1 className="mb-5">Create an Account</h1>
                                    <div className="col-lg-6 col-md-8">
                                        <div className="login_wrap widget-taber-content background-white">
                                            <div className="padding_eight_all bg-white">
                                                <div className="heading_s1">
                                                    <p className="mb-30">Already have an account? <Link to="/Login">Login</Link></p>
                                                </div>
                                                <Formik
                                                    initialValues={initialValues}
                                                    validationSchema={CreateLoginValidationSchema}
                                                    onSubmit={onSubmit}
                                                >
                                                    {({ values, isSubmitting, isValid, dirty }) => (
                                                        <Form method="post">
                                                            <div className="form-group">
                                                                <Field
                                                                    type="text"
                                                                    name="username"
                                                                    placeholder="Username"
                                                                    className='form-control'
                                                                />
                                                                <ErrorMessage name='username' component='p' className='text-danger' />
                                                            </div>
                                                            <div className="form-group">
                                                                <Field
                                                                    type="email"
                                                                    name="email"
                                                                    placeholder="Email"
                                                                    className='form-control'
                                                                />
                                                                <ErrorMessage name='email' component='p' className='text-danger' />
                                                            </div>
                                                            <div className="form-group">
                                                                <Field
                                                                    type="password"
                                                                    name="password"
                                                                    placeholder="Password"
                                                                    className='form-control'
                                                                />
                                                                <ErrorMessage name='password' component='p' className='text-danger' />
                                                            </div>
                                                            <div className="form-group">
                                                                <Field
                                                                    type="password"
                                                                    name="confirmPassword"
                                                                    placeholder="Confirm password"
                                                                    className='form-control'
                                                                />
                                                                <ErrorMessage name='confirmPassword' component='p' className='text-danger' />
                                                            </div>

                                                            <div className="login_footer form-group mb-50">
                                                                <div className="chek-form">
                                                                    <div className="custome-checkbox">
                                                                        <Field
                                                                            className="form-check-input"
                                                                            type="checkbox"
                                                                            name="terms"
                                                                            id="exampleCheckbox12"
                                                                        />
                                                                        <label className="form-check-label" htmlFor="exampleCheckbox12"><span>I agree to terms &amp; Policy.</span></label>
                                                                    </div>
                                                                </div>
                                                                {/* <a href="page-privacy-policy.html"><i className="fi-rs-book-alt mr-5 text-muted" />Learn more</a> */}
                                                            </div>
                                                            <div className="form-group mb-30">
                                                                <button
                                                                    type="submit"
                                                                    className="btn btn-fill-out btn-block hover-up font-weight-bold"
                                                                    disabled={isSubmitting || !(isValid && dirty && values.terms)}
                                                                >
                                                                    {isSubmitting ? "Submitting..." : 'Submit & Register'}
                                                                </button>
                                                            </div>

                                                            <p className="font-xs text-muted"><strong>Note:</strong>Your personal data will be used to support your experience throughout this website, to manage access to your account, and for other purposes described in our privacy policy</p>
                                                        </Form>
                                                    )}
                                                </Formik>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-lg-6 d-none d-lg-block">
                                        <img className="border-radius-15" src="assets/imgs/page/Sign-up.png" alt="Login" />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>

    )
}

export default CreateAccount;